var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.258,
    height: 128.541,
    viewBox: "0 0 136.258 128.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(-249 -1150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor_3_",
    "data-name": "monitor (3)",
    transform: "translate(249 1135.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0 14.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M189.545,386.261l-2.575,11.8,19.792,6.408,19.792-6.408-2.583-11.8-17.625-6.792Z",
    transform: "translate(-137.212 -282.34)",
    fill: "#b8acac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M0,341.177a7.21,7.21,0,0,0,7.2,7.192H129.067a7.209,7.209,0,0,0,7.191-7.192v-7.325L66.4,327.836,0,333.852Z",
    transform: "translate(0 -244.448)",
    fill: "#f3eae6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M122.808,455.723v5.2a1.222,1.222,0,0,0,1.217,1.216h71.293a1.222,1.222,0,0,0,1.217-1.216v-5.2a6.435,6.435,0,0,0-6.422-6.408H129.23a6.435,6.435,0,0,0-6.422,6.408Z",
    transform: "translate(-90.125 -333.598)",
    fill: "#f3eae6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M0,21.692V103.9H136.258V21.692a7.209,7.209,0,0,0-7.191-7.192H7.2A7.21,7.21,0,0,0,0,21.692Z",
    transform: "translate(0 -14.5)",
    fill: "#b8acac",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M37.937,54.652v65.764a1.544,1.544,0,0,0,1.546,1.545H152.409a1.542,1.542,0,0,0,1.539-1.545V54.652a1.547,1.547,0,0,0-1.539-1.545H39.483a1.549,1.549,0,0,0-1.546,1.545Z",
    transform: "translate(-27.841 -42.833)",
    fill: "#ffca91",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M80.771,94.036v56.886h93.88V94.036a1.477,1.477,0,0,0-1.476-1.467H82.247A1.472,1.472,0,0,0,80.771,94.036Z",
    transform: "translate(-59.275 -71.793)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M193.551,404.991l-1.123,5.129H218.3c2.167,0,2.363.463,2.779,2.392l.934,4.275h8.549l-2.583-11.8H193.551Z",
    transform: "translate(-141.217 -301.07)",
    fill: "#9d9696",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M342.122,455.723v5.2a1.222,1.222,0,0,1-1.217,1.216h10.653a1.222,1.222,0,0,0,1.217-1.216v-5.2a6.435,6.435,0,0,0-6.422-6.408H335.708A6.433,6.433,0,0,1,342.122,455.723Z",
    transform: "translate(-246.366 -333.598)",
    fill: "#e0d2ce",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M193.826,223.962H125.752a2.056,2.056,0,1,1,0-4.111h68.074a2.056,2.056,0,1,1,0,4.111Z",
    transform: "translate(-90.777 -152.351)",
    fill: "#b8acac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M193.826,223.962H125.752a2.056,2.056,0,1,1,0-4.111h68.074a2.056,2.056,0,1,1,0,4.111Z",
    transform: "translate(-90.777 -162.351)",
    fill: "#b8acac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M177.285,223.962H125.267a2.13,2.13,0,0,1,0-4.111h52.018a2.13,2.13,0,0,1,0,4.111Z",
    transform: "translate(-90.777 -173.351)",
    fill: "#746e6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M193.826,260.919H125.752a2.056,2.056,0,1,1,0-4.111h68.074a2.056,2.056,0,1,1,0,4.111Z",
    transform: "translate(-90.777 -178.308)",
    fill: "#b8acac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(339.34 1173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(-0.34)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 18,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "medical",
    transform: "translate(1.123 1.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M14,30.159a3.748,3.748,0,0,0,2.1.676,2.36,2.36,0,0,1-3.076.811A3.852,3.852,0,0,0,14.468,32.8s-1.876,1.318-3.008-.27a1.672,1.672,0,0,1-2.6.2H7.694a1.672,1.672,0,0,1-2.6-.2c-1.132,1.588-3.008.27-3.008.27a3.852,3.852,0,0,0,1.454-1.149,2.36,2.36,0,0,1-3.076-.811,3.748,3.748,0,0,0,2.1-.676c-2.4.2-2.556-1.69-2.556-1.69a7.78,7.78,0,0,0,2.776.1c.459-.048.931-.118,1.4-.2,2.129-.372,2.265,2.7,3.515,2.7H8.858c1.251,0,1.385-3.076,3.515-2.7a10.4,10.4,0,0,0,4.178.1S16.4,30.362,14,30.159Zm0,0",
    transform: "translate(0 -27.42)",
    fill: "#fcb52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M91.237,31.071l-.422,1.152c-3.343,0-1.947-2.48-3.966-2.642-1.1-.089-1.013-1.013-1.013-1.013h0c.459-.048.931-.118,1.4-.2,2.129-.372,2.265,2.7,3.515,2.7Zm0,0",
    transform: "translate(-83.059 -27.42)",
    fill: "#f99830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M259.023,31.071l.422,1.152c3.343,0,1.947-2.48,3.966-2.642,1.1-.089,1.013-1.013,1.013-1.013h0c-.459-.048-.931-.118-1.4-.2-2.129-.372-2.265,2.7-3.515,2.7Zm0,0",
    transform: "translate(-250.65 -27.42)",
    fill: "#f99830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M241.02,42.273V56.883a.551.551,0,0,1-1.1,0V42.273Zm0,0",
    transform: "translate(-232.163 -40.907)",
    fill: "#f99830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M255.528,42.273V56.883a.344.344,0,1,1-.617,0V42.273Zm0,0",
    transform: "translate(-246.67 -40.907)",
    fill: "#fcb52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M121.4,142.411c-.161.605-1.073,1.481-3.09,1.992-1.708.432-2.336,1.157-2.163,1.85a1.17,1.17,0,0,0,.171.371,1.642,1.642,0,0,1-.8-1.685c.345-1.634,4.558-1.571,4.558-2.988,0-1.711-7.057-.766-7.057-4.252,0-2.712,2.372-2.768,2.932-2.223a.391.391,0,0,1,.1.155,1.488,1.488,0,0,1-1.379,1.915s-.855,1.213,3.281,1.9c3.089.515,3.779,1.711,3.447,2.962Zm0,0",
    transform: "translate(-109.358 -130.833)",
    fill: "#79a879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M140.577,141.951c0,1.417,4.214,1.354,4.558,2.988a1.642,1.642,0,0,1-.8,1.685c.536-.791.025-1.711-1.992-2.222s-2.929-1.387-3.09-1.992c-.332-1.251.358-2.447,3.447-2.962,4.137-.69,3.281-1.9,3.281-1.9a1.488,1.488,0,0,1-1.379-1.915.519.519,0,0,1,.262-.269c.752-.406,2.772-.165,2.772,2.338,0,3.486-7.057,2.541-7.057,4.252Zm0,0",
    transform: "translate(-134.675 -130.832)",
    fill: "#79a879"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(3.653 4.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M144.332,293.174c.536-.791.025-1.711-1.992-2.222s-2.929-1.387-3.09-1.992a1.89,1.89,0,0,1,1.238-2.312,11.584,11.584,0,0,0,1.2.352c-1.879.586-1.81,1-1.81,1.521,0,.661.673,1.42,2.556,1.94S145.489,292.018,144.332,293.174Zm0,0",
    transform: "translate(-138.329 -281.753)",
    fill: "#5d895d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M258.443,144.454a10.564,10.564,0,0,0-1.2-.265l-.284-.049c3.813-.7,3-1.853,3-1.853a1.488,1.488,0,0,1-1.379-1.915.519.519,0,0,1,.262-.269,2.409,2.409,0,0,0,1.738,1.828S261.325,143.514,258.443,144.454Zm0,0",
    transform: "translate(-252.307 -139.943)",
    fill: "#5d895d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M189.91,411.3c.237.087.5.169.776.244-.109.044-.2.085-.282.124-.8.4-.785,1.016-.479,1.758.05.121.108.244.171.371a1.642,1.642,0,0,1-.8-1.685,1.343,1.343,0,0,1,.618-.811Zm0,0",
    transform: "translate(-186.793 -402.38)",
    fill: "#5d895d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M118.526,143.771c-.271-.117-.565-.222-.862-.322,1.182-.4,2.4-.734,2.4-1.5,0-1.082-2.823-1.1-4.9-1.852h0c-1.206-.436-2.159-1.119-2.159-2.4,0-2.712,2.372-2.768,2.932-2.223-1.029.081-2.363.492-2.363,2.077,0,2.9,7.35,2.149,7.169,4.49-.079,1.014-1.084,1.272-2.223,1.727Zm0,0",
    transform: "translate(-113.011 -135.203)",
    fill: "#5d895d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M217.421,1.367a1.365,1.365,0,1,1-.937-1.3,1.367,1.367,0,0,1,.937,1.3Zm0,0",
    transform: "translate(-207.748 0)",
    fill: "#f99830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M243.151,3.43a.987.987,0,1,1-.937-1.3,1.367,1.367,0,0,1,.937,1.3Zm0,0",
    transform: "translate(-233.478 -2.064)",
    fill: "#fcb52f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M155.321,158.64a.254.254,0,1,1,.249-.2A.256.256,0,0,1,155.321,158.64Zm0,0",
    transform: "translate(-150.055 -153.022)",
    fill: "#3b3d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M343.431,158.642a.254.254,0,1,1,.247-.2A.256.256,0,0,1,343.431,158.642Zm0,0",
    transform: "translate(-332.084 -153.023)",
    fill: "#3b3d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M266.2,29.905c0-.228-.133-.413-.3-.413s-.3.185-.3.413.133.413.3.413S266.2,30.134,266.2,29.905Zm0,0",
    transform: "translate(-257.024 -28.539)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.6160b42e011574117d753716664d7629.svg";
export { ForwardRef as ReactComponent };